import { withInstall } from '@zoryn/utils'
import Cascader from './src/cascader.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCascader: SFCWithInstall<typeof Cascader> = withInstall(Cascader)

export default ZCascader

export * from './src/cascader'
export * from './src/instances'
